/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 524
// module chunks = 0